import React from 'react'
import { Redirect } from 'react-router-dom'
import WithPermission from 'Components/SharedComponents/WithPermission/WithPermission'
import { SelfServe } from './SelfServe'
import { SelfServeWidgets } from './SelfServeWidgets'
import { FunderSharedGoals } from './FunderSharedGoals/FunderSharedGoals'
import { ImpactReport } from './ImpactReport/ImpactReport'
import ImpactReportDashboard from '../Impact/ImpactReportDashboard/ImpactReportDashboard'
import { FunderReport } from './FunderReport/FunderReport'
import { NeedsAssessmentTrigger } from './NeedsAssessmentTrigger/NeedsAssessmentTrigger'
import { CheckInSurvey } from '../CheckInSurvey/CheckInSurvey'
import { GoalsWizard } from './GoalsWizard/GoalsWizard'
import { CoachingEventPage } from './GroupCoaching/CoachingEventPage'
import { NonprofitProfile } from './NonprofitProfile/NonprofitProfile'
import FunderAdminWidget from './FunderAdmin'
import CohortAdminWidget from './CohortAdmin'
import NonprofitAdminWidget from './NonprofitAdmin'
import UserAdminWidget from './UserAdmin'
import AiCoachingAdminWidget from './AiCoachingAdmin'
import JobAdminWidget from './JobAdmin'
import OneOnOneCoachingAdminWidget from './OneOnOneCoachingAdmin'
import { CoachingInterventionsWidget } from './CoachingInterventions'

export default {
  path: '/internal',
  exact: false,
  Component: WithPermission(SelfServe, ['page:internal:self_serve'], true),
  access: 'USER',
  routes: [
    {
      path: '/internal/self-serve',
      exact: true,
      Component: SelfServeWidgets,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/funder-shared-goals',
      exact: true,
      Component: FunderSharedGoals,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/impact-report',
      exact: true,
      Component: ImpactReport,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/impact-report-dashboard',
      exact: true,
      Component: ImpactReportDashboard,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/needs-assessment/trigger-new-surveys',
      exact: true,
      Component: NeedsAssessmentTrigger,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/funder-report',
      exact: true,
      Component: FunderReport,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/funder-admin',
      exact: false,
      Component: FunderAdminWidget,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/cohort-admin',
      exact: false,
      Component: CohortAdminWidget,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/nonprofit-admin',
      exact: false,
      Component: NonprofitAdminWidget,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/user-admin',
      exact: false,
      Component: UserAdminWidget,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/check-in-survey',
      exact: true,
      Component: CheckInSurvey,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/goals-wizard',
      exact: true,
      Component: GoalsWizard,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/coaching-event-management',
      exact: true,
      Component: CoachingEventPage,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/nonprofit-profile',
      exact: true,
      Component: function redirectToNonprofitAdmin() {
        return React.createElement(Redirect, {
          to: '/internal/self-serve/nonprofit-admin',
        })
      },
      access: 'USER',
    },
    {
      path: '/internal/self-serve/nonprofit-profile/:id',
      exact: true,
      Component: NonprofitProfile,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/one-on-one-coaching',
      exact: false,
      Component: OneOnOneCoachingAdminWidget,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/ai-coaching-admin',
      exact: false,
      Component: AiCoachingAdminWidget,
    },
    {
      path: '/internal/self-serve/coaching-interventions',
      exact: false,
      Component: CoachingInterventionsWidget,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/job-admin',
      exact: false,
      Component: JobAdminWidget,
      access: 'USER',
    },
  ],
}
